import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { ListItem } from "@website/ui/list-item";
import { Popover } from "@website/ui/popover";
import { numberConvert } from "@website/utils/number-convert";
import { useToggle } from "@website/utils/use-toggle/useToggle";

export function SupportAgent() {
  const [supportMenuIsOpen, toggleSupportMenu] = useToggle(false);
  return (
    <div className="relative">
      <Button
        StartIcon={<MaterialIcon name="support_agent" />}
        aria-label="نمایش لینک های پشتیبانی"
        color="neutral"
        onClick={toggleSupportMenu}
        role="button"
        variant="text"
        className="!mx-0 max-xl:!hidden"
      >
        پشتیبانی
      </Button>

      <Button
        EndIcon={<MaterialIcon name="support_agent" />}
        className="!mx-0 xl:!hidden"
        color="neutral"
        equalDimension
        onClick={toggleSupportMenu}
        variant="text"
      />

      <Popover
        gap="16px"
        horizontalPosition="end"
        onClose={toggleSupportMenu}
        open={supportMenuIsOpen}
      >
        <div className="w-[312px] rounded-lg py-2">
          <ListItem
            StartIcon={<MaterialIcon name="support_agent" />}
            aria-label="تماس با پشتیبانی"
            href="tel:+982192000123"
            role="link"
            subtitle={
              <div className="text-end" style={{ direction: "ltr" }}>
                {numberConvert("+98 21 92000123", {
                  locale: "fa"
                })}
              </div>
            }
            title="تماس با پشتیبانی"
          />
        </div>
      </Popover>
    </div>
  );
}
